import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutpassportComponent } from './passport/layoutpassport.component';
import { SharedModule } from '../shared/shared.module';
import { HomeLayoutComponent } from './home/home-layout.component';
import { HeaderComponent } from './home/header/header.component';
import { SystemButtomComponent } from './home/header/system-buttom/system-buttom.component';
import { ChatModule } from '../core/common/app-im/app-chat.module';
 

const chatModule = [ChatModule]
 
@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    ...chatModule
  ],
  declarations: [
    LayoutpassportComponent,
    HomeLayoutComponent,
    HeaderComponent,
    SystemButtomComponent
  ],
  exports: [
    LayoutpassportComponent,
    HomeLayoutComponent,
    HeaderComponent,
    SystemButtomComponent,
 
  ]
})
export class LayoutModule { }
